import React from 'react'
import Formdata from '../Admin/index'

const index = () => {
  return (
    <div>
      <Formdata/>
    </div>
  )
}

export default index
